






import Informational from "@/views/modules/messaging-inbox/chat-log-entries/information/informational.vue";
import InternalComment from "@/views/modules/messaging-inbox/chat-log-entries/information/internalComment.vue";
import Webchat from "@/views/modules/messaging-inbox/chat-log-entries/information/webchat.vue";
import { EntryDirection, InformationEntryDto } from "@saysimple-platform/dtos";
import { defineComponent, PropType } from "@vue/composition-api";
import { BAlert } from "bootstrap-vue";

export default defineComponent({
    components: {
        BAlert,
        Informational,
        InternalComment,
        Webchat,
    },
    props: {
        entry: {
            type: Object as PropType<InformationEntryDto>,
            required: true,
        },
        groupDirection: {
            type: String as PropType<EntryDirection>,
            required: false,
        },
    },
});
